module.exports = __webpack_public_path__ + "static/quartier_G-00d6eacba3994e23301ad55a05f42a0e.png";